/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubVenueRequestDto as DigiworkMaitreDPosDtoAdvertiserSubVenueRequestDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Advertiser/sub-venue-request-dto';

export interface AddSubVenue$Params {
      body?: DigiworkMaitreDPosDtoAdvertiserSubVenueRequestDto
}

export function addSubVenue(http: HttpClient, rootUrl: string, params?: AddSubVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addSubVenue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addSubVenue.PATH = '/api/gmn/Venue/addsubvenue';
